var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientPortalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2868_47583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 3.13401 4.13401 0 8 0H42C45.866 0 49 3.13401 49 7V41C49 44.866 45.866 48 42 48H8C4.13401 48 1 44.866 1 41V7Z",
    fill: "#DBF0DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25 24H31.75V22.3L33.225 23.15L33.975 21.85L32.5 21L33.975 20.15L33.225 18.85L31.75 19.7V18H30.25V19.7L28.775 18.85L28.025 20.15L29.5 21L28.025 21.85L28.775 23.15L30.25 22.3V24ZM15 33C14.45 33 13.9792 32.8042 13.5875 32.4125C13.1958 32.0208 13 31.55 13 31V17C13 16.45 13.1958 15.9792 13.5875 15.5875C13.9792 15.1958 14.45 15 15 15H35C35.55 15 36.0208 15.1958 36.4125 15.5875C36.8042 15.9792 37 16.45 37 17V31C37 31.55 36.8042 32.0208 36.4125 32.4125C36.0208 32.8042 35.55 33 35 33H15ZM22 26C22.8333 26 23.5417 25.7083 24.125 25.125C24.7083 24.5417 25 23.8333 25 23C25 22.1667 24.7083 21.4583 24.125 20.875C23.5417 20.2917 22.8333 20 22 20C21.1667 20 20.4583 20.2917 19.875 20.875C19.2917 21.4583 19 22.1667 19 23C19 23.8333 19.2917 24.5417 19.875 25.125C20.4583 25.7083 21.1667 26 22 26ZM15.1 31H28.9C28.2 29.75 27.2333 28.7708 26 28.0625C24.7667 27.3542 23.4333 27 22 27C20.5667 27 19.2333 27.3542 18 28.0625C16.7667 28.7708 15.8 29.75 15.1 31Z",
    fill: "#4CAF50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2868_47583",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2868_47583"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2868_47583",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientPortalIcon);
export default __webpack_public_path__ + "static/media/patient-portal-icon.06f0c07daf23fa40e87ba70a306ccf37.svg";
export { ForwardRef as ReactComponent };